module.exports = __webpack_public_path__ + "img/firmware-animate.b0d664a9.svg";